
import requests from './httpService';
const TrainerService = {
  getAllTrainer(id) {
    return requests.post(`/trainer/find`);
  },
   deleteAzureImage(body){
      return requests.post(`/trainer/deleteazureimage`,body);
  
    },
  creteTrainer(body){
    return requests.post('/trainer/add',body); 
  },
  deleteTrainer(body){
    return requests.delete(`/trainer/${body._id}`); 
  },

  upadeTrainer(body) {
    return requests.put(`/trainer/${body._id}`,body); 
  },

  getTrainerNameById(body){
    return requests.post('/trainer/getTrainerNameById',body);
  },

  uploadImage(body) {
    return requests.post(`/trainer/uploadimage`,body);
  },
};

export default TrainerService;
